// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KLQUI","placeholdersHeader":"styles_placeholdersHeader__3yD4S","editorStyle":"styles_editorStyle__3R79D","placeholdersBox":"styles_placeholdersBox__2h_FM"};